export default __webpack_public_path__ + "static/media/weakRel.3da07295.gif";